import { ErrorFatalComponent } from './components/ErrorFatalComponent';
import { ErrorRetryComponent } from './components/ErrorRetryComponent';
import { UploadAgainComponent } from './components/UploadAgainComponent';
import { UploadComponent } from './components/UploadComponent';
import { UploadedComponent } from './components/UploadedComponent';
import { UploadingComponent } from './components/UploadingComponent';

export enum UploadState {
  RETRY = 'retry',
  RETRY_UPLOAD = 'retry-upload',
  FATAL = 'fatal',
  UPLOAD = 'upload',
  UPLOAD_AGAIN = 'upload-again',
  UPLOAD_CORRUPTED = 'upload-corrupted',
  UPLOADING = 'uploading',
  UPLOADED = 'uploaded',
}

import { UploadScreenChildProps } from './UploadScreen.types';

export const ComponentMap: Record<UploadState, React.ComponentType<UploadScreenChildProps>> = {
  [UploadState.RETRY]: ErrorRetryComponent,
  [UploadState.RETRY_UPLOAD]: ErrorRetryComponent,
  [UploadState.FATAL]: ErrorFatalComponent,
  [UploadState.UPLOAD_AGAIN]: UploadAgainComponent,
  [UploadState.UPLOAD_CORRUPTED]: UploadAgainComponent,
  [UploadState.UPLOADED]: UploadedComponent,
  [UploadState.UPLOADING]: UploadingComponent,
  [UploadState.UPLOAD]: UploadComponent,
};
